var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.62032 6.61216L2.20238 0.367312C2.0827 0.25086 1.94062 0.158485 1.78425 0.0954615C1.62788 0.032438 1.46028 -1.27662e-07 1.29103 -1.12865e-07C0.949209 -8.29825e-08 0.621387 0.132126 0.379683 0.367312C0.260003 0.483764 0.165068 0.622013 0.100298 0.774165C0.0355273 0.926317 0.00219128 1.08939 0.00219129 1.25408C0.00219132 1.58668 0.137979 1.90566 0.379683 2.14085L5.89911 7.49893L0.379684 12.857C0.259376 12.9731 0.163884 13.1113 0.0987183 13.2635C0.0335522 13.4157 1.18711e-06 13.5789 1.20152e-06 13.7438C1.21593e-06 13.9087 0.0335523 14.0719 0.0987183 14.2241C0.163884 14.3763 0.259376 14.5144 0.379684 14.6306C0.499011 14.7476 0.640977 14.8405 0.797394 14.9039C0.953811 14.9674 1.12158 15 1.29103 15C1.46048 15 1.62825 14.9674 1.78467 14.9039C1.94109 14.8405 2.08305 14.7476 2.20238 14.6306L5.41135 11.5081L8.62032 8.3857C8.74063 8.26959 8.83612 8.13146 8.90128 7.97926C8.96645 7.82706 9 7.66381 9 7.49893C9 7.33405 8.96645 7.17081 8.90128 7.01861C8.83612 6.86641 8.74063 6.72827 8.62032 6.61216Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector(2).9bba7714c73d678a598e605cddfd501f.svg";
export { ForwardRef as ReactComponent };